module.exports = __webpack_public_path__ + "img/main.00f7de9a.png";